import { Button, type ButtonProps } from "~/components/design-system/components"

type GateProps = "disabled" | "loading" | "requires" | "allowedTitle"

/**
 * An action a component renders as its own xs Button. A link (`href`) takes no disabled, loading
 * or permission props: Button renders it as a plain `<a>` that would ignore them.
 */
export type LabelledAction = { label: string } & Pick<ButtonProps, "onClick"> &
  (
    | (Pick<ButtonProps, GateProps> & { href?: never; target?: never })
    | (Pick<ButtonProps, "target"> & { href: string } & Partial<Record<GateProps, never>>)
  )

export const LabelledActionButton = ({
  action,
  variant,
  className,
}: {
  action: LabelledAction
  variant: "neutral" | "transparent"
  className?: string
}) => {
  const { label, ...rest } = action
  return (
    <Button variant={variant} size="xs" className={className} {...rest}>
      {label}
    </Button>
  )
}
